// @ts-nocheck
import React from "react"
import { useStore } from "../../containers"
import { SuccessCell } from "./SuccessCell"
import { InfoCell } from "./InfoCell"
import { Fisica } from "./Fisica"
import { Juridica } from "./Juridica"
import { CardLayout } from "./CardLayout"
import { OkMessage } from "./OkMessage"

export function DocumentUploadCell() {
  const { active, uploadView, isCpf, isDocumentOk, setDocumentOk } = useStore()
  return (
    <CardLayout disabled={!active} done={isDocumentOk}>
      {uploadView === "WAITING_ACCOUNT" && <InfoCell />}
      {uploadView === "WAITING_UPLOAD" && <OkMessage />}
      {uploadView === "WAITING_UPLOAD" &&
        (isCpf ? <Fisica onChange={setDocumentOk} /> : <Juridica onChange={setDocumentOk} />)}
      {uploadView === "DONE" && <SuccessCell />}
    </CardLayout>
  )
}
